<app-complete-pages-navbar></app-complete-pages-navbar>
<div class="wrapper wrapper-full-page">
  <div class="page-header register-page header-filter" filter-color="black"
       style="background-image: url('./assets/img/pages/register/register-background.jpg'); background-size: cover; background-position: top center;">
    <div class="container respect-responsiveness">
      <div class="row">
        <div class="col-md-6 ml-auto mr-auto">
          <div class="card card-signup">
            <div class="card-header card-header-primary text-center">
              <h3 class="card-title text-center">{{'REGISTER.REGISTER' | translate}}</h3>
              <div class="social-line" id="tabsContainer">
                <ul class="nav nav-tabs justify-content-center" role="tablist">
                  <li class="nav-item">
                    <a class="nav-link cursor-pointer active" data-toggle="tab" role="tablist" (click)="setUserType('company')">
                      {{'REGISTER.COMPANY' | translate}}
                    </a>
                  </li>
                  <!--<li class="nav-item">
                    <a class="nav-link cursor-pointer" data-toggle="tab" role="tablist" (click)="setUserType('forwarder')">
                      {{'REGISTER.FORWARDER' | translate}}
                    </a>
                  </li>-->
                </ul>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 mr-auto">
                  <div class="form">
                    <app-required-input customId="name"
                                        type="text"
                                        [formGroup]="registerFormGroup"
                                        icon="face"
                                        text="REGISTER_PAGE.NAME_INPUT">
                    </app-required-input>
                    <app-required-input customId="surname"
                                        type="text"
                                        [formGroup]="registerFormGroup"
                                        icon="face"
                                        text="REGISTER_PAGE.SURNAME_INPUT">
                    </app-required-input>
                    <app-email-input customId="mail"
                                     type="email"
                                     [formGroup]="registerFormGroup"
                                     icon="mail"
                                     *ngIf="!comesFromInvi"
                                     text="REGISTER_PAGE.EMAIL_INPUT">
                    </app-email-input>
                    <app-tel-input customId="phone"
                                   [formGroup]="registerFormGroup"
                                   icon="call">
                    </app-tel-input>
                    <app-required-input customId="enterprise"
                                        type="text"
                                        [formGroup]="registerFormGroup"
                                        icon="apartment"
                                        *ngIf="!comesFromInvi"
                                        text="REGISTER_PAGE.ENTERPRISE_INPUT">
                    </app-required-input>
                    <app-required-input customId="nif"
                                        type="text"
                                        [formGroup]="registerFormGroup"
                                        icon="badge"
                                        *ngIf="!comesFromInvi"
                                        errorText="MY_COMPANY_PAGE.MY_COMPANY_CIF_ERROR"
                                        text="REGISTER_PAGE.NIF_INPUT"
                                        (error)="this.sendNifErrorEventMixPanel()">
                    </app-required-input>
                    <app-password-input customId="password"
                                        type="password"
                                        [formGroup]="registerFormGroup"
                                        icon="lock_outline"
                                        text="REGISTER_PAGE.PASSWD_INPUT"
                                        [confirmPasswordComponent]="confirmPasswordComponent">
                    </app-password-input>
                    <app-password-input #confirmPasswordComponent
                                        customId="confirmPassword"
                                        type="password"
                                        [formGroup]="registerFormGroup"
                                        icon="lock_outline"
                                        text="REGISTER_PAGE.PASSWD_INPUT_CONFIRMATION">
                    </app-password-input>
                    <app-check-input [formGroup]="registerFormGroup"
                                     customId="checkTerms"
                                     text="REGISTER_PAGE.TERMS_AND_CONDITIONS"
                                     errorText="INPUTS.ERRORS.TERMS_AND_CONDITIONS">
                    </app-check-input>
                    <div class="text-center">
                      <a mat-raised-button class="btn btn-primary" (click)="checkFields()">{{'REGISTER.GET_STARTED' | translate}}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <app-complete-pages-footer></app-complete-pages-footer>
    </div>
  </div>
</div>
